import { styled } from 'goober';
import { useEffect, useState } from 'preact/hooks';

import { IQuizItem } from '../types/quiz';
import {
  addBackListener,
  setCurrentQuestionIdx,
  setTotalQuestions,
  updateProgress,
} from '../utils/quiz';

import { Questions } from './questions/Questions';

export interface IQuizProps {
  initial: number;
  quiz: IQuizItem[];
  onFinish: (answers: Record<string, string | string[]>) => Promise<void>;
  onAnswerSubmit: (
    idx: number,
    q: IQuizItem,
    answer?: string | string[],
  ) => Promise<void>;
  ids: {
    backButttonId: string;
    totalTextId: string;
    currentTextId: string;
    progressBarId: string;
    percentageId: string;
  };
}

export const Quiz = ({
  ids,
  quiz,
  initial,
  onFinish,
  onAnswerSubmit,
}: IQuizProps) => {
  const [idx, setIdx] = useState(initial);
  const [answers, setAnswer] = useState({});
  const q = quiz[idx];

  const onSubmit = async (v?: string | string[]) => {
    let value = v;
    if (q.type === 'chart' || q.type === 'info') {
      value = 'true';
    }

    const newAnswers = {
      ...answers,
      [q.key]: value,
    };

    setAnswer(newAnswers);
    onAnswerSubmit(idx, q, value);

    if (idx === quiz.length - 1) {
      await onFinish(newAnswers);
    } else {
      const newIdx = idx + 1;
      setIdx(newIdx);
    }
  };

  useEffect(() => {
    updateProgress(ids.progressBarId, ids.percentageId, quiz.length, idx);
    setCurrentQuestionIdx(ids.currentTextId, idx + 1);
    setTotalQuestions(ids.totalTextId, quiz.length);
    return addBackListener(ids.backButttonId, idx, setIdx);
  }, [idx]);

  return (
    <Container key={q.title} className="question-card">
      <Questions item={q} onSubmit={onSubmit} />
    </Container>
  );
};

const Container = styled('div')`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
`;
